export default "__VITE_ASSET__J5_$$3Rq__"